import React from "react";
import "./SocialIcons.css";
import styled from "styled-components";
import { DarkTheme } from "../components/Themes";
import { motion } from "framer-motion";

const Line = styled(motion.span)`
  width: 2px;
  height: 6rem;
  margin-left: 6px;
  background-color: ${(props) =>
    props.color === "dark" ? DarkTheme.text : DarkTheme.body};
`;

const Icons = (props) => {
  const OnGIthubClick = () => {
    const url = "http://www.github.com/ekanshev";
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };
  const OnLinkedinClick = () => {
    const url = "https://www.linkedin.com/in/ekansh-kumar-933ab2160/";
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };
  const OnInstragramCLik = () => {
    const url = "https://www.instagram.com/ekanshev.06/";
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };

  return (
    <div className="wrapper">
      <div className="button">
        <div className="icon">
          <i className="fab fa-github" onClick={OnGIthubClick}></i>
        </div>
        <span onClick={OnGIthubClick}>Github</span>
      </div>
      <div className="button">
        <div className="icon">
          <i className="fa-brands fa-linkedin" onClick={OnLinkedinClick}></i>
        </div>
        <span onClick={OnLinkedinClick}>LinkedIn</span>
      </div>
      <div className="button">
        <div className="icon">
          <i className="fab fa-instagram" onClick={OnInstragramCLik}></i>
        </div>
        <span onClick={OnInstragramCLik}>Instagram</span>
      </div>
      <Line
        color={props.theme}
        initial={{
          height: 0,
        }}
        animate={{
          height: "6rem",
        }}
        transition={{
          type: "spring",
          duration: 1,
          delay: 0.8,
        }}
      />
    </div>
  );
};

export default Icons;
